/*
 * File: Dashboard.tutorial.jsx
 * Project: Machine Trust Platform
 * File Created: Monday, 14th June 2021 3:30:29 pm
 * Author: Tarek Sanger (tarek@nuenergy.ai)
 * -----
 * Last Modified: Thursday, 26th August 2021 3:54:39 pm
 * Modified By: Archit Bhatia (archit.bhatia@nuenergy.ai)
 * -----
 * Copyright 2017 - 2021 NuEnergy.ai, NuEnergy.ai
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTour from '../CustomTour';
import Tutorial from '../TutorialContainer';

const AIATutorial = (): JSX.Element => {
  const STEPS = [
    {
      selector: '[data-tut="AIA"]',
      content: () => <StepOne />,
    },
  ];

  return <CustomTour steps={STEPS} />;
};

export default AIATutorial;

function StepOne() {
  const { t } = useTranslation();

  return <Tutorial header={t('AIA.tutorial.label')}>{t('AIA.tutorial.step.1')}</Tutorial>;
}
